import classNames from 'classnames/bind';
import { withPriceSeperator } from '@flight-workspace/common-client/src/util/number';
import { IGroupedPromotion } from 'common/promotion';
import PromotionInfo from 'list/common/promotionInfo';
import styles from './index.module.scss';

const cx = classNames.bind(styles);

interface IProps {
  promotion: IGroupedPromotion;
}

export default function Promotion({
  promotion: { paymentMethod, summaryByType, discountedPrice },
}: IProps) {
  if (!discountedPrice) return null;
  return (
    <div className={cx('Promotion')}>
      <div className={cx('desc')}>
        <PromotionInfo
          npayIcon={<i className={cx('npay')} title="npay" />}
          paymentMethod={paymentMethod}
          summaryByType={summaryByType}
        />
      </div>
      <div className={cx('price')}>
        <b className={cx('num')}>{withPriceSeperator(discountedPrice)}</b>
        <span className={cx('unit')}>원</span>
      </div>
    </div>
  );
}
